(function () {
    'use strict';
    /*
     * Copyright (c) 2014-15 In Hand Health.
     * All rights reserved.
     */

    angular
        .module('ihh-common-web')
        .directive('ihhThumbnailBox', ihhThumbnailBox);

    function ihhThumbnailBox () {
        return {
            restrict: 'AE',
            transclude: true,
            scope: {
                imageHref: '@',
                thumbnailRight: '=',
                width: '='
            },
            templateUrl: 'layouts/thumbnail-box.tpl.html'
        };
    }
})();